import React, { useContext } from "react";
import { MdDarkMode, MdLightMode } from "react-icons/md";

import ColorModeContext from "../../layout/themeContext";

const DarkMode = ({ themeToggle }) => {
  const { colorMode } = useContext(ColorModeContext);
  const mode = colorMode?.mode || "light";

  const handleClick = () => {
    if (colorMode?.toggleColorMode) {
      colorMode.toggleColorMode();
      return;
    }

    if (themeToggle) {
      themeToggle();
    }
  };

  const Icon = mode === "dark" ? MdLightMode : MdDarkMode;
  const label = mode === "dark" ? "Ativar modo claro" : "Ativar modo escuro";

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      title={label}
      className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-[10px] border-0 bg-transparent p-0 text-inherit outline-none transition-colors hover:bg-farmazon-hover"
    >
      <Icon size={20} />
    </button>
  );
};

export default DarkMode;
